"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Play } from "lucide-react";
const videos = [{
  id: 1,
  title: "Championship Final – Ultimate 8 Ball Tournament",
  thumbnail: "https://rackemjoelivestream.net/wp-content/uploads/2026/03/Black-Futuristic-8-Ball-Pool-Tournament-Tabloid.jpg",
  url: "/OnDemandGalleryPage"
}, {
  id: 2,
  title: "Hoosier Tour Stop BigShots Pub",
  thumbnail: "https://img.youtube.com/vi/x06vhS976JI/maxresdefault.jpg",
  url: "https://www.youtube.com/watch?v=x-2ajUYrD3s&t=323s"
}, {
  id: 3,
  title: "Hoosier Tour Stop Brickyard Billiards",
  thumbnail: "https://rackemjoelivestream.net/wp-content/uploads/2026/03/brickyard.jpg",
  url: "/https://www.youtube.com/watch?v=x-2ajUYrD3s&t=317s"
}, {
  id: 4,
  title: "2nd Annual Indy Cup",
  thumbnail: "https://rackemjoelivestream.net/wp-content/uploads/2026/03/Polish_20250406_200006261-scaled.jpg",
  url: "https://www.youtube.com/watch?v=pE-uHR3miwE&t=717s"
}];
export default function OnDemandPreview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section ref={ref} className={`relative bg-background py-16 px-4 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground mb-3">
            On‑Demand Preview
          </h2>
          <p className="text-muted-foreground text-lg">
            Catch up on the best moments from recent tournaments and action matches
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {videos.map((video, i) => <Link key={video.id} to={i === 0 ? "https://www.youtube.com/watch?v=SRbnCsb7AHY" : i === 2 ? "https://www.youtube.com/watch?v=x-2ajUYrD3s&t=323s" : i === 3 ? "https://www.youtube.com/watch?v=pE-uHR3miwE" : video.url} newTab={i === 0 || i === 2 || i === 3} data-index={i} className="group relative block overflow-hidden rounded-lg border-2 border-primary transition-all duration-[var(--duration-medium)] hover:scale-[1.02] hover:shadow-[0_0_16px_hsla(4,95%,52%,0.6)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40">
              <div className="relative aspect-video bg-surface">
                <img src={video.thumbnail} alt={video.title} className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]">
                  <Play className="w-16 h-16 text-primary drop-shadow-lg" />
                </div>
              </div>
              <div className="relative overflow-hidden bg-surface/90 backdrop-blur-sm">
                <div className={`px-4 py-3 transform transition-transform duration-[var(--duration-medium)] ${isVisible ? "translate-y-0" : "translate-y-full"}`} style={{
              transitionDelay: `${i * 75}ms`
            }}>
                  <h3 className="font-display text-lg font-semibold text-foreground line-clamp-2">
                    {video.title}
                  </h3>
                </div>
              </div>
            </Link>)}
        </div>

        <div className="mt-10 text-center">
          <Link to="/OnDemandGalleryPage" className="inline-flex items-center justify-center rounded-md bg-primary text-foreground-primary px-8 py-3 font-semibold hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            View Full Gallery
          </Link>
        </div>
      </div>
    </section>;
}